import actions from "~/shared/actions";
import type { ForvaltningsForm } from "~/shared/components/investeringsvalg/forvaltningsformer";
import type { Spareprofil } from "~/shared/components/investeringsvalg/spareprofiler";
import type { Action } from "~/utils/actions";

export interface Prices {
	forvaltningskost: { [K in ForvaltningsForm]: ForvaltningPriceInfo };
	administrasjonskost: number;
	adminkostIGVerdi: boolean;
	satsRentegaranti: number;
	takAdminkostIGVerdi: number;
	regular?: Prices;
	fondspriser?: { [K in string]: number };
}

export interface ForvaltningPriceInfo {
	available: boolean;
	spareprofiler: SpareprofilerPrice;
}

export type SpareprofilerPrice = { [K in Spareprofil]: Price };

export interface Price {
	max: number;
	min: number;
	actualPrice: number;
	regular?: Price;
	utbetaling: Price;
}

export interface PricesState {
	[policyNumber: number]: Prices;
	sl: Prices;
	pkb: Prices;
}

const defaultState = {} as PricesState;

export default function pricesReducer(state = defaultState, action: Action): PricesState {
	switch (action.type) {
		case actions.GET_SL_PRICES_RESPONSE:
			return { ...state, sl: action.data };
		case actions.GET_PKB_PRICES_RESPONSE:
			return { ...state, pkb: action.data };
		case actions.GET_POLICY_PRICES_RESPONSE:
			return {
				...state,
				[action.data.policyNumber]: {
					...state[action.data.policyNumber],
					administrasjonskost: action.data.result.administrasjonskost,
					adminkostIGVerdi: action.data.result.adminkostIGVerdi,
					takAdminkostIGVerdi: action.data.result.takAdminkostIGVerdi,
					forvaltningskost: action.data.result.forvaltningskost,
					regular: action.data.regular,
					satsRentegaranti: action.data.result.satsRentegaranti,
				},
			};
		case actions.GET_FUND_PRICES_RESPONSE:
			return {
				...state,
				[action.data.policyNumber]: {
					...state[action.data.policyNumber],
					fondspriser: action.data.result,
				},
			};
		default:
			return state;
	}
}
